export const phoneFromDddAndPhoneNumber = (ddd: number, phoneNumber: number) => {
  if (!ddd || !phoneNumber) {
    return null;
  }

  const phoneNumberString = phoneNumber.toString();
  const phoneDashIndex = phoneNumberString.length - 4;

  return `(${ddd}) ${phoneNumberString.slice(0, phoneDashIndex)}-${phoneNumberString.slice(phoneDashIndex)}`;
};
